import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./lib/auth";
import { TranslationProvider } from "./contexts/Translation";
import { translations } from "./lib/i18n";
import { ApiDataProvider } from "./contexts/ApiData";
import { LoginProvider } from "./contexts/LoginProvider";
import { BrowserRouter } from "react-router-dom";
import { OrganizationProvider } from "./contexts/UserProvider";
import { NotificationsProvider } from "./contexts/Notifications";
import { loadRuntimeConfig } from "./lib/runtimeConfig";
import SystemMessage from "./components/SystemMessage/Index";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const render = () =>
  root.render(
  <React.StrictMode>
    <TranslationProvider translations={translations}>
      <AuthProvider callbackPath="/callback">
        <LoginProvider>
          <ApiDataProvider>
            <OrganizationProvider>
              <NotificationsProvider>
                <BrowserRouter>
                  <App />
                </BrowserRouter>
              </NotificationsProvider>
            </OrganizationProvider>
          </ApiDataProvider>
        </LoginProvider>
      </AuthProvider>
    </TranslationProvider>
  </React.StrictMode>,
);

loadRuntimeConfig()
  .then(render)
  .catch((e) => {
    console.error(e);
    root.render(
      <TranslationProvider translations={translations}>
        <SystemMessage isError message="errorLogin" />
      </TranslationProvider>,
    );
  });
